export const devicesUrls = {
  driver: serialNumber => `api/v0/flares/landing_page/${serialNumber}/`,
};
